import { FC } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { SelectPartnersModalContent } from './components/selectPartnersModalContent/SelectPartnersModalContent'

interface ISelectPartnersModalProps {
  show: boolean
  onSubmit: () => void
  onClose: () => void
}

export const SelectPartnersModal: FC<ISelectPartnersModalProps> = ({ show, onSubmit, onClose }) => {
  return (
    <ModalDialog
      size={'xl'}
      show={show}
      content={SelectPartnersModalContent}
      contentProps={{
        onSubmitData: onSubmit,
      }}
      onClose={onClose}
      closeOnOutsideClick={false}
    />
  )
}
